import { PricingCard } from '../../components/pricing';
import './index.css';

export const Pricing = () => {
    return (
        <div className="pricing-page">
            <PricingCard />
        </div>
    );
}